// @flow
// $FlowIssue need to update to a more recent flow version
import React, { useCallback } from 'react';
import { Field, Form } from 'formik';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/styles';
import { Paper } from '@material-ui/core';
import FormikInput from '../../../../components/FormikInput';
import SubmitButton from '../../../../components/SubmitButton';
import styles from './styles';

type Props = {
    dirty: boolean,
    handleSubmit: Function,
    isSubmitting: boolean,
    isValid: boolean,
    setStatus: (status: any) => void,
    status?: any,
};

const useStyles = makeStyles(styles, { name: 'ForgotPasswordForm' });

export default function ForgotPasswordForm(props: Props) {
    const { dirty, handleSubmit, isSubmitting, isValid, setStatus, status } = props;

    const classes = useStyles(props);
    const { t } = useTranslation();

    const handleChange = useCallback(() => {
        if (status && status.error) {
            setStatus({ error: null });
        }
    }, [status, setStatus]);

    return (
        <Paper className={classes.paper} elevation={0}>
            <Form name="forgotPassword" onChange={handleChange}>
                <h1>{t('forgotPassword.form.heading')}</h1>
                {status && status.error
                    ? <div className={classes.error}>{status.error}</div>
                    : null
                }
                <p>{t('forgotPassword.form.subheading')}</p>
                <fieldset className={classes.fieldset}>
                    <Field
                      classes={{ input: classes.input }}
                      component={FormikInput}
                      fullWidth
                      label={t('shared.auth.email')}
                      labelPlacement="top"
                      margin="dense"
                      name="email"
                      placeholder={t('shared.auth.emailPlaceholder')}
                      required
                      variant="outlined"
                    />
                </fieldset>
                <SubmitButton
                  className={classes.submitButton}
                  color="secondary"
                  disabled={!dirty || isSubmitting || !isValid}
                  onClick={handleSubmit}
                  size="large"
                  submitting={isSubmitting}
                  type="submit"
                  variant="contained"
                >
                    {t('forgotPassword.form.submit')}
                </SubmitButton>
            </Form>
        </Paper>
    );
}
